export const blogsPerPage = 6;

export const CHIP_ARTICLE_CATEGORIES = [
  { name: 'Blockchain', color: '#db8127' },
  { name: 'Business stories', color: '#b3991b' },
  { name: 'Business Stories', color: '#b3991b' },
  { name: 'AI', color: '#579120' },
  { name: 'Code stories', color: '#199159' },
  { name: 'Code Stories', color: '#199159' },
  { name: 'Software Development', color: '#19918f' },
  { name: 'Software development', color: '#19918f' },
  { name: 'Fintech', color: '#197591' },
  { name: 'FinTech', color: '#197591' },
  { name: 'AWS', color: '#911991' },
  { name: 'UX', color: '#91195b' },
  { name: 'Mobile Development', color: '#a33b3b' },
  { name: 'Mobile development', color: '#a33b3b' },
];
